// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__zBNUR","crumb":"Breadcrumbs_crumb__2NdVY"};